import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { TunaFishBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/tuna'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class TunaFishBlockView extends Container {
  private movieclip: MovieClip;

  constructor(props: TunaFishBlockProps) {
    super();
    blockPositionView(this, props);
    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
      y: 1,
    });
    this.movieclip.play('fish_state02');
  }

  public static assets() {
    return Object.values(manifest());
  }

  public async playTransition() {
    await this.movieclip.playAsync('fish_tranisition_1_2');
    this.movieclip.play('fish_state02');
  }
}
